import React from 'react';
import { Typography, Box, Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { formatarData, isRevisaoPendente } from "../../utils/dateFormatters";

const styles = (theme) => ({
    dadosItem: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    infoContainer: {
        flex: "1 1 300px",
    },
    infoText: {
        margin: "0.313rem 0",
        color: "#222222",
    },
    qrContainer: {
        textAlign: "center",
        color: "#222222",
        padding: theme.spacing(2),
    },
    badgePendente: {
        backgroundColor: "#E74C3C",
        color: "#FFFFFF",
        marginTop: "0.625rem",
        borderRadius: "4px",
    },
});

const EquipamentDetailsInfoContainer = ({
    classes,
    equipment,
    showQRCode = true,
    currentLanguage
}) => {
    const {
        id,
        nome,
        marca,
        modelo,
        ca,
        serie,
        ultima_revisao,
        proxima_revisao
    } = equipment || {};

    const pendente = isRevisaoPendente(proxima_revisao);

    return (
        <Box className={classes.dadosItem}>
            <Box className={classes.infoContainer}>
                <Typography className={classes.infoText}>
                    <strong>ID:</strong> {id || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_item_label}</strong> {nome || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_brand_label}</strong> {marca || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_model_label}</strong> {modelo || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_ca_label}</strong> {ca || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_serial_label}</strong> {serie || '--'}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_last_rev_label}</strong> {formatarData(ultima_revisao)}
                </Typography>
                <Typography className={classes.infoText}>
                    <strong>{currentLanguage.bepiService.shared.shared_equip_next_rev_label}</strong> {formatarData(proxima_revisao)}
                </Typography>
                {pendente && (
                    <Chip
                        label={currentLanguage.bepiService.shared.shared_equip_pending_revision_label}
                        className={classes.badgePendente}
                        size="small"
                    />
                )}
            </Box>

            {showQRCode && (
                <Box className={classes.qrContainer}>
                    <Typography style={{ color: '#222222' }}>
                        {currentLanguage.bepiService.shared.shared_equip_qr_code_label}
                    </Typography>
                    <Box
                        style={{
                            width: 140,
                            height: 140,
                            backgroundColor: '#000',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                    >
                        QRCODE
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default withStyles(styles)(EquipamentDetailsInfoContainer);
